import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { Record } from 'immutable';
import { createLogger } from 'redux-logger';
import reducer from '../reducer';
import { IState, RecordState } from '../types';
import { getCardsRenderInfo, expandGameState } from '../../utils';
import { getDropElements, makeHints } from '../../functions/hints';
import { makeLayout } from '../../functions/request';
import { Orientation } from '../../utils/detectOrientation';

const logger = createLogger({
  stateTransformer: state => state.toJS(),
});

export function makeState(seed?: number, force: boolean = false): RecordState {
  const pulledState = localStorage.getItem('__free__cell__v1__state');

  if (!force && pulledState !== null) {
    //@ts-ignore
    return Record(JSON.parse(pulledState))();
  }

  const requestState = makeLayout(seed);

  const cardsRenderInfo = getCardsRenderInfo(0);
  const expandedState = expandGameState(requestState.gameState);
  const dropElements = getDropElements(expandedState);
  const hints = makeHints(dropElements, 0, 4);

  const defaultState: IState = {
    id: Number(requestState.seed),
    size: 0,
    orientation: Orientation.Portrait,
    history: [],
    cardsRenderInfo,
    gameState: expandedState,
    dropElements,
    volume: !localStorage.getItem('volumeOff'),
    hints,
    hintNumber: 0,
    settings: {
      superMove: false,
      listening: true,
      superMoveSequence: 0,
    },
    gameData: {
      scores: 0,
      steps: 0,
      cardsAtHome: 0,
      startTime: new Date().getTime(),
      isWin: false,
    },
    modals: {
      newGame: {
        isVisible: false,
      },
      restart: {
        isVisible: false,
      },
      rules: {
        isVisible: false,
      },
    },
    numberOfEmptyPiles: 0,
    numberOfEmptySlots: 4,
    cardsOverflowMessage: {
      isVisible: false,
      maxCards: 0,
      needCards: 0,
    },
  };

  return Record(defaultState)();
}

const middleware = [thunk];

if (process.env.NODE_ENV !== 'production') {
  //@ts-ignore
  middleware.push(logger);
}

export default function makeStore() {
  //@ts-ignore
  return createStore(reducer, makeState(), applyMiddleware(...middleware));
}
